import { render, staticRenderFns } from "./edit-model.vue?vue&type=template&id=04a35c72&scoped=true&"
import script from "./edit-model.vue?vue&type=script&lang=ts&"
export * from "./edit-model.vue?vue&type=script&lang=ts&"
import style0 from "./edit-model.vue?vue&type=style&index=0&id=04a35c72&prod&lang=css&"
import style1 from "./edit-model.vue?vue&type=style&index=1&id=04a35c72&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a35c72",
  null
  
)

export default component.exports